import Vue from 'vue'
import ut from '@/utils'

import {Resource} from 'vue-resource'

const Product = {
  id: null,
  name: '',
  recipe_doc: null,
  revinue_amount: '',
  job_volume_price: '',
  sell_price: '',
  sell_price_usd: '',
  measurement: '',
}

const ProductResource = new Resource('/', {}, {
  list: {
    method: 'GET',
    url: 'warehouse/producttype/list/',
  },
  details: {
    method: 'GET',
    url: 'warehouse/producttype/detail/{id}/',
  },
  create: {
    method: 'POST',
    url: 'warehouse/producttype/create/',
  },
  update: {
    method: 'PUT',
    url: 'warehouse/producttype/update/{id}/',
  },
  remove: {
    method: 'DELETE',
    url: 'warehouse/producttype/delete/{id}/',
  },
})

export default {
  namespaced: true,

  state: {
    data: null,

    fetching: false,
    model: ut.deepClone(Product),

    saving: false,
    deleting: {}
  },

  getters: {
    getProduct: (state) => (id) => state.data?.results?.find(m => m.id === id),
  },

  mutations: {
    setItems(state, data) {
      state.data = data
    },

    setModel(state, data) {
      state.model = {...ut.deepClone(Product), ...data}

      if (state.model.recipe_doc && ('object' === typeof state.model.recipe_doc)) {
        state.model.recipe_doc_elements = state.model.recipe_doc.recipeelements
        state.model.recipe_doc_name = state.model.recipe_doc.name
        state.model.recipe_doc_description = state.model.recipe_doc.description
        state.model.recipe_doc = state.model.recipe_doc.id
      }
    },
  },

  actions: {
    fetch({state, commit}, filters = {}) {
      filters.limit = filters.limit || 1000

      if (!state.fetching) {
        commit('setItems', null)
        state.fetching = ProductResource.list(ut.objFilter(filters))
          .then((response) => {
            commit('setItems', response.body)
          })
          .finally(() => state.fetching = false)
      }

      return state.fetching
    },

    show({state, commit}, id) {
      if (!state.fetching) {
        commit('setModel', {})
        state.fetching = ProductResource.details({id})
          .then(({body}) => {
            commit('setModel', body)
          })
          .finally(() => state.fetching = false)
      }

      return state.fetching
    },

    save({state, commit}) {
      state.saving = true
      let promise
      if (state.model.id) {
        promise = ProductResource.update({id: state.model.id}, state.model)
      } else {
        promise = ProductResource.create(state.model)
      }

      return promise
        .then(({body}) => {
          commit('setModel', body)
        })
        .finally(() => state.saving = false)
    },

    remove({state, dispatch}, id) {
      Vue.set(state.deleting, id, true)
      return ProductResource.remove({id})
        .then(() => dispatch('fetch'))
        .finally(() => Vue.set(state.deleting, id, false))
    },
  },
}
